import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/ErrorMessages/errorMessages.container"
    ).then((module) => ({
        default: module.ErrorMessages
    }))
);
